import { render, staticRenderFns } from "./choiceThyy.vue?vue&type=template&id=ae650100&scoped=true&"
import script from "./choiceThyy.vue?vue&type=script&lang=js&"
export * from "./choiceThyy.vue?vue&type=script&lang=js&"
import style0 from "./choiceThyy.vue?vue&type=style&index=0&id=ae650100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae650100",
  null
  
)

export default component.exports